export default "{\n    \"guaranteeFasterPaymentLabel\": \"Asegura un pago más rápido.\",\n    \"learnMoreButtonLabel\": \"Más información\"\n}\n"